import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { clinicConfig } from "@/config/clinic";
import { fadeUp, viewport } from "@/lib/reveal";

export const FinalCTA = ({ onRequest }) => {
  return (
    <section data-testid="final-cta" className="bg-background py-20 md:py-24">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={viewport}
          className="relative overflow-hidden border border-border bg-primary px-8 py-14 text-primary-foreground md:px-16 md:py-20"
        >
          <div className="grain absolute inset-0" aria-hidden />
          <div className="relative z-10 flex flex-col items-start justify-between gap-8 lg:flex-row lg:items-center">
            <div className="max-w-2xl">
              <h2 className="font-serif text-4xl font-medium leading-tight tracking-tight md:text-5xl">
                Ready when you are — in person or online.
              </h2>
              <p className="mt-5 text-lg leading-relaxed text-primary-foreground/85">
                Sign in to Doc Talk to message securely, ask questions, and manage
                your care. New to the practice? Request a visit and we'll take it
                from there.
              </p>
            </div>
            <div className="flex w-full flex-col gap-3 sm:w-auto sm:flex-row lg:flex-col">
              <a
                href={clinicConfig.patientPortalUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="final-signin-cta"
                className="group inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-accent px-8 py-4 text-base font-semibold text-accent-foreground transition-transform hover:-translate-y-0.5"
              >
                Patient Sign In
                <ArrowUpRight className="h-5 w-5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" strokeWidth={1.75} />
              </a>
              <button
                onClick={onRequest}
                data-testid="final-request-cta"
                className="inline-flex items-center justify-center rounded-full border border-primary-foreground/30 px-8 py-4 text-base font-semibold text-primary-foreground transition-colors hover:bg-primary-foreground/10"
              >
                Request Care
              </button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTA;
